import { AVIS_INICIALITZAR, AVIS_VISUALITZACIO_OBTENIR_COMENTARIS, AVIS_VISUALITZACIO_ELIMINAR_COMENTARI } from '../../../../actions/actionTypes';

const ESTAT_INICIAL = [];

const tots = (state = ESTAT_INICIAL, action) => {
    switch (action.type) {
        case AVIS_INICIALITZAR:
            return ESTAT_INICIAL;

        case AVIS_VISUALITZACIO_OBTENIR_COMENTARIS:
            return action.comentaris;

        case AVIS_VISUALITZACIO_ELIMINAR_COMENTARI:
            return state.filter(comentari => comentari.id !== action.id);

        default:
            return state;
    }
};

export default tots;



// WEBPACK FOOTER //
// ./src/reducers/avis/visualitzacio/comentaris/tots.js